import { FC } from 'react'

interface Props {
	isActive: boolean
}

export const SearchIcon: FC<Props> = ({ isActive }) => {
	return (
		<svg
			width="21"
			height="22"
			viewBox="0 0 21 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<ellipse
				cx="9.86667"
				cy="9.89812"
				rx="8.86667"
				ry="8.90728"
				stroke={isActive ? '#2D4056' : '#BCC6D8'}
				strokeWidth="2"
			/>
			<path
				d="M20 20.0779C19.0107 19.084 16.8334 16.8967 16.8334 16.8967"
				stroke={isActive ? '#2D4056' : '#BCC6D8'}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	)
}
